<template>
  <div v-html="pageContent"></div>
</template>

<script>

export default {
  name: "HtmlComponent",
  components: {
    // 
  },
  props: ['dataResults'],
  data() {
    return {
      pageContent: ''
    };
  },
  mounted() {
    console.log("this.dataResults ==>", this.dataResults);
    this.pageContent = (this.dataResults && JSON.parse(this.dataResults)) || '<h1>No Data results, fallback html rendered </h1>';
  },
  methods: {
    // 
  }
};

</script>


